"use client";

import { c as _c } from "react/compiler-runtime";
import { Code, Menu, X } from "lucide-react";
import Link from "next/link";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useUser } from "@/hooks/useUser";
import { useAppConfig } from "@/lib/config";
export function Header() {
  const $ = _c(30);
  const config = useAppConfig();
  const {
    user,
    isLoading
  } = useUser();
  const isAuthenticated = !!user && !isLoading;
  const [menuOpen, setMenuOpen] = useState(false);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Link href="/" className="flex items-center gap-2"><div className="flex h-7 w-7 items-center justify-center rounded-lg bg-foreground text-background"><Code className="h-4 w-4" /></div><span className="font-semibold text-lg">DevPass</span><span className="hidden sm:inline text-xs text-muted-foreground">by LLM Gateway</span></Link>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <Button variant="ghost" size="sm" asChild={true}><Link href="/coding-models">Models</Link></Button>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Button variant="ghost" size="sm" asChild={true}><Link href="/guides">Guides</Link></Button>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="ghost" size="sm" asChild={true}><Link href="/pricing">Pricing</Link></Button>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <Button variant="ghost" size="sm" asChild={true}><Link href="/compare">Compare</Link></Button>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== config.docsUrl) {
    t5 = <Button variant="ghost" size="sm" asChild={true}><a href={config.docsUrl} target="_blank" rel="noopener noreferrer">Docs</a></Button>;
    $[5] = config.docsUrl;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== isAuthenticated) {
    t6 = isAuthenticated ? <Button size="sm" asChild={true}><Link href="/dashboard">Dashboard</Link></Button> : <><Button variant="ghost" size="sm" asChild={true}><Link href="/login">Sign in</Link></Button><Button size="sm" asChild={true}><Link href="/signup">Get Started</Link></Button></>;
    $[7] = isAuthenticated;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== t5 || $[10] !== t6) {
    t7 = <div className="hidden sm:flex items-center gap-3">{t1}{t2}{t3}{t4}{t5}{t6}</div>;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== menuOpen) {
    t8 = () => setMenuOpen(!menuOpen);
    $[12] = menuOpen;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const t9 = menuOpen ? "Close menu" : "Open menu";
  let t10;
  if ($[14] !== menuOpen) {
    t10 = menuOpen ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />;
    $[14] = menuOpen;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t8 || $[18] !== t9) {
    t11 = <button type="button" onClick={t8} className="sm:hidden p-2 -mr-2" aria-label={t9}>{t10}</button>;
    $[16] = t10;
    $[17] = t8;
    $[18] = t9;
    $[19] = t11;
  } else {
    t11 = $[19];
  }
  let t12;
  if ($[20] !== t11 || $[21] !== t7) {
    t12 = <div className="container mx-auto px-4 py-4 flex items-center justify-between">{t0}{t7}{t11}</div>;
    $[20] = t11;
    $[21] = t7;
    $[22] = t12;
  } else {
    t12 = $[22];
  }
  let t13;
  if ($[23] !== config.docsUrl || $[24] !== isAuthenticated || $[25] !== menuOpen) {
    t13 = menuOpen && <div className="sm:hidden border-t border-border/50 px-4 py-4 space-y-3"><Link href="/coding-models" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Models</Link><Link href="/guides" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Guides</Link><Link href="/pricing" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Pricing</Link><Link href="/compare" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Compare</Link><a href={config.docsUrl} target="_blank" rel="noopener noreferrer" className="block text-sm text-muted-foreground hover:text-foreground transition-colors">Docs</a>{isAuthenticated ? <Button size="sm" className="w-full" asChild={true}><Link href="/dashboard" onClick={() => setMenuOpen(false)}>Dashboard</Link></Button> : <><Link href="/login" className="block text-sm text-muted-foreground hover:text-foreground transition-colors" onClick={() => setMenuOpen(false)}>Sign in</Link><Button size="sm" className="w-full" asChild={true}><Link href="/signup" onClick={() => setMenuOpen(false)}>Get Started</Link></Button></>}</div>;
    $[23] = config.docsUrl;
    $[24] = isAuthenticated;
    $[25] = menuOpen;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t12 || $[28] !== t13) {
    t14 = <header className="border-b border-border/50">{t12}{t13}</header>;
    $[27] = t12;
    $[28] = t13;
    $[29] = t14;
  } else {
    t14 = $[29];
  }
  return t14;
}